module.exports = __webpack_public_path__ + "static/media/Paus hörnsoffa 2 rekliner micro grå detalj 2023 2.cbb838d6.jpg";